module.exports = __webpack_public_path__ + "img/IT0000375525937.34168607.png";